import React, { FunctionComponent } from 'react'
import { TopLevelRoute } from '../../../containers/routes'
import NotFoundPage from '../../../pages/not_found'
import { FeatureFlag } from '../feature_flag'

interface IProps {
  active?: boolean;
}
export const RouteFeatureFlag: FunctionComponent<IProps> = ({ active = true, children }) =>
  <FeatureFlag
    active={active}
    fallback={<TopLevelRoute component={NotFoundPage} />}>
    {children}
  </FeatureFlag>
